import { useEffect, useState, useRef, useMemo } from "react";

import { usePagination } from "../hooks/usePagination";
import UniversalPagination from "../common/UniversalPagination";
import Sidebar from '../components/Sidebar'
import Header from '../components/Header'

import Swal from "sweetalert2";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

import { API_BASE } from "../config/api";

const initialForm = {
    nombre: "",
    correo: "",
    puesto: "",
    bio: "",
};

function Experts() {
    const initialForm = {
        nombre: "",
        correo: "",
        puesto: "",
        bio: "",
    };

    const initialEditForm = {
        Instructor_ID: null,
        nombre: "",
        correo: "",
        puesto: "",
        bio: "",
        fotoActual: "",
    };

    const [experts, setExperts] = useState([]);
    const [loadingExperts, setLoadingExperts] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [form, setForm] = useState(initialForm);
    const [photo, setPhoto] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showValidation, setShowValidation] = useState(false);

    const [selectedExpert, setSelectedExpert] = useState(null);
    const [loadingViewExpert, setLoadingViewExpert] = useState(false);

    const [editForm, setEditForm] = useState(initialEditForm);
    const [editPhoto, setEditPhoto] = useState(null);
    const [isUpdatingExpert, setIsUpdatingExpert] = useState(false);
    const [showEditValidation, setShowEditValidation] = useState(false);

    const [searchTerm, setSearchTerm] = useState("");
    const [sortOrder, setSortOrder] = useState("default");

    const editFileInputRef = useRef(null);

    const [alert, setAlert] = useState({
        type: "",
        message: "",
    });

    const fileInputRef = useRef(null);

    const quillModules = useMemo(
        () => ({
            toolbar: [
                [{ header: [1, 2, 3, false] }],
                ["bold", "italic", "underline", "strike"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link", "clean"],
            ],
        }),
        []
    );

    const quillFormats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "list",
        "bullet",
        "link",
    ];

    const loadExperts = async () => {
        try {
            setLoadingExperts(true);
            setErrorMessage("");

            const response = await fetch(`${API_BASE}/api/admin/expertsList`, {
                method: "GET",
                credentials: "include",
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || "No fue posible obtener los expertos");
            }

            setExperts(data?.data || []);
        } catch (error) {
            console.error("Error al cargar expertos:", error);
            setErrorMessage(error.message || "Ocurrió un error al cargar expertos");
        } finally {
            setLoadingExperts(false);
        }
    };

    useEffect(() => {
        loadExperts();
    }, []);

    const getPlainTextFromHtml = (html = "") => {
        return html
            .replace(/<(.|\n)*?>/g, " ")
            .replace(/&nbsp;/g, " ")
            .replace(/\s+/g, " ")
            .trim();
    };

    const isNombreInvalid = !form.nombre.trim();
    const isPuestoInvalid = !form.puesto.trim();
    const isPhotoInvalid = !photo;

    const isEditNombreInvalid = !editForm.nombre.trim();
    const isEditPuestoInvalid = !editForm.puesto.trim();

    const resetForm = () => {
        setForm(initialForm);
        setPhoto(null);
        setShowValidation(false);

        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const handleChange = (e) => {
        const { id, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [id]: value,
        }));
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files?.[0] || null;
        setPhoto(selectedFile);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setAlert({ type: "", message: "" });
        setShowValidation(true);

        if (
            isNombreInvalid ||
            isPuestoInvalid ||
            isPhotoInvalid
        ) {
            setAlert({
                type: "info",
                message: "Todos los campos son obligatorios.",
            });
            return;
        }

        try {
            setIsSubmitting(true);

            const formData = new FormData();
            formData.append("nombre", form.nombre.trim());
            formData.append("correo", form.correo.trim());
            formData.append("puesto", form.puesto.trim());
            formData.append("bio", form.bio);
            formData.append("photo", photo);

            const response = await fetch(`${API_BASE}/api/admin/expertsList`, {
                method: "POST",
                credentials: "include",
                body: formData,
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || "No fue posible agregar el instructor");
            }

            setAlert({
                type: "success",
                message: data?.message || "Instructor agregado correctamente.",
            });

            resetForm();
            await loadExperts();
        } catch (error) {
            console.error("Error al agregar instructor:", error);
            setAlert({
                type: "danger",
                message: error.message || "Ocurrió un error al agregar el instructor.",
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    // Funcion para ver detalle del experto 
    const handleViewInstructor = async (item) => {
        try {
            setLoadingViewExpert(true);
            setErrorMessage("");
            setSelectedExpert(null);

            const response = await fetch(
                `${API_BASE}/api/admin/expertsList/${item.Instructor_ID}`,
                {
                    method: "GET",
                    credentials: "include",
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || "No fue posible obtener el detalle del instructor");
            }

            setSelectedExpert(data?.data || null);
        } catch (error) {
            console.error("Error al consultar instructor:", error);
            setErrorMessage(error.message || "Ocurrió un error al consultar el instructor");
        } finally {
            setLoadingViewExpert(false);
        }
    };

    // Funcion para editar experto
    const resetEditForm = () => {
        setEditForm(initialEditForm);
        setEditPhoto(null);
        setShowEditValidation(false);

        if (editFileInputRef.current) {
            editFileInputRef.current.value = "";
        }
    };

    const handleEditInputChange = (e) => {
        const { id, value } = e.target;

        setEditForm((prev) => ({
            ...prev,
            [id]: value,
        }));
    };

    const handleEditPhotoChange = (e) => {
        const selectedFile = e.target.files?.[0] || null;
        setEditPhoto(selectedFile);
    };

    const handleEditInstructor = async (item) => {
        try {
            setAlert({ type: "", message: "" });
            setErrorMessage("");
            setShowEditValidation(false);
            setEditPhoto(null);

            if (editFileInputRef.current) {
                editFileInputRef.current.value = "";
            }

            const response = await fetch(
                `${API_BASE}/api/admin/expertsList/${item.Instructor_ID}`,
                {
                    method: "GET",
                    credentials: "include",
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || "No fue posible obtener el instructor");
            }

            const expert = data?.data;

            setEditForm({
                Instructor_ID: expert?.Instructor_ID || null,
                nombre: expert?.Instructor_Nombre || "",
                correo: expert?.Instructor_Correo || "",
                puesto: expert?.Instructor_Puesto || "",
                bio: expert?.Instructor_Bio || "",
                fotoActual: expert?.Instructor_Foto || "",
            });
        } catch (error) {
            console.error("Error al cargar instructor para edición:", error);
            setAlert({
                type: "danger",
                message: error.message || "Ocurrió un error al cargar el instructor.",
            });
        }
    };

    const handleUpdateInstructor = async (e) => {
        e.preventDefault();

        setAlert({ type: "", message: "" });
        setErrorMessage("");
        setShowEditValidation(true);

        if (
            isEditNombreInvalid ||
            isEditPuestoInvalid
        ) {
            setAlert({
                type: "info",
                message: "Todos los campos son obligatorios para editar el instructor.",
            });
            return;
        }

        try {
            setIsUpdatingExpert(true);

            const formData = new FormData();
            formData.append("nombre", editForm.nombre.trim());
            formData.append("correo", editForm.correo.trim());
            formData.append("puesto", editForm.puesto.trim());
            formData.append("bio", editForm.bio);

            if (editPhoto) {
                formData.append("photo", editPhoto);
            }

            const response = await fetch(
                `${API_BASE}/api/admin/expertsList/${editForm.Instructor_ID}`,
                {
                    method: "PUT",
                    credentials: "include",
                    body: formData,
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || "No fue posible actualizar el instructor");
            }

            setAlert({
                type: "success",
                message: data?.message || "Instructor actualizado correctamente.",
            });

            resetEditForm();
            await loadExperts();

            const modalElement = document.getElementById("editExpertModal");
            if (modalElement && window.bootstrap) {
                const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
                modalInstance?.hide();
            }
        } catch (error) {
            console.error("Error al actualizar instructor:", error);
            setAlert({
                type: "danger",
                message: error.message || "Ocurrió un error al actualizar el instructor.",
            });
        } finally {
            setIsUpdatingExpert(false);
        }
    };

    // Funcion para eliminar experto
    const handleDeactivateExpert = async (expert) => {
        try {
            const result = await Swal.fire({
                title: "¿Desactivar experto?",
                html: `
                    <div style="font-size:15px;">
                        Esta acción es <b>irreversible</b> desde este panel.<br/><br/>
                        Si deseas <b>activar nuevamente</b> este experto,
                        deberás consultar con el área de soporte.
                    </div>
                `,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, desactivar",
                cancelButtonText: "Cancelar",
                reverseButtons: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#6c757d",
            });

            if (!result.isConfirmed) return;

            const response = await fetch(
                `${API_BASE}/api/admin/expertsList/${expert.Instructor_ID}`,
                {
                    method: "DELETE",
                    credentials: "include",
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(
                    data?.message || "No fue posible desactivar el experto"
                );
            }

            await Swal.fire({
                title: "Experto desactivado",
                text: `${expert.Instructor_Nombre} fue desactivado correctamente.`,
                icon: "success",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#198754",
            });

            await loadExperts();
        } catch (error) {
            console.error("Error al desactivar experto:", error);

            Swal.fire({
                title: "Ocurrió un error",
                text:
                    error.message ||
                    "No fue posible desactivar el experto",
                icon: "error",
                confirmButtonText: "Cerrar",
                confirmButtonColor: "#dc3545",
            });
        }
    };

    // Filtros
    const filteredAndSortedExperts = useMemo(() => {
        const normalizedSearch = searchTerm.trim().toLowerCase();

        let result = [...experts];

        if (normalizedSearch) {
            result = result.filter((item) =>
                (item.Instructor_Nombre || "")
                    .toLowerCase()
                    .includes(normalizedSearch)
            );
        }

        switch (sortOrder) {
            case "name_asc":
                result.sort((a, b) =>
                    (a.Instructor_Nombre || "").localeCompare(
                        b.Instructor_Nombre || "",
                        "es",
                        { sensitivity: "base" }
                    )
                );
                break;

            case "name_desc":
                result.sort((a, b) =>
                    (b.Instructor_Nombre || "").localeCompare(
                        a.Instructor_Nombre || "",
                        "es",
                        { sensitivity: "base" }
                    )
                );
                break;

            case "oldest":
                result.sort((a, b) => Number(a.Instructor_ID) - Number(b.Instructor_ID));
                break;

            case "newest":
                result.sort((a, b) => Number(b.Instructor_ID) - Number(a.Instructor_ID));
                break;

            case "default":
            default:
                // Respetamos el orden actual que ya llega del backend
                break;
        }

        return result;
    }, [experts, searchTerm, sortOrder]);

    // Paginador
    const {
        currentPage,
        totalPages,
        totalItems,
        paginatedItems,
        visiblePages,
        startItem,
        endItem,
        goToPage,
        goToPreviousPage,
        goToNextPage,
        resetPagination,
        hasPreviousPage,
        hasNextPage,
    } = usePagination(filteredAndSortedExperts, 10, 5);

     const handleClearFilters = () => {
        setSearchTerm("");
        setSortOrder("default");
        resetPagination();
    };


    useEffect(() => {
        resetPagination();
    }, [searchTerm, sortOrder]);

    return (
        <>
        <Sidebar/>
        <main class="main-content">
            <Header/>
            <div class="content-inner container-fluid pb-0" id="page_layout">
                
                <div class="d-flex justify-content-between align-items-center flex-wrap mb-4 gap-3">
                    <div class="d-flex flex-column">
                        <h3>Lista de Expertos</h3>
                        <p class="text-primary mb-0">Panduit Core</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <div class="card">
                            <div class="card-header d-flex justify-content-end gap-3 flex-wrap">
                                <div className="row g-2 align-items-end w-100">
                                <div className="col-md-4">
                                    <label className="form-label mb-1">Buscar</label>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Buscar por nombre del experto..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label mb-1">Ordenar</label>
                                    <select
                                        className="form-select form-select-sm"
                                        value={sortOrder}
                                        onChange={(e) => setSortOrder(e.target.value)}
                                    >
                                        <option value="default">Orden por defecto</option>
                                        <option value="name_asc">Orden alfabético A-Z</option>
                                        <option value="name_desc">Orden alfabético Z-A</option>
                                        <option value="newest">Más recientes</option>
                                        <option value="oldest">Más antiguos</option>
                                    </select>
                                </div>

                                <div className="col-md-4 d-flex justify-content-end gap-2 ms-auto">
                                    <button
                                        type="button"
                                        className="btn btn-secondary-subtle btn-sm"
                                        onClick={handleClearFilters}
                                        title="Limpiar búsqueda"
                                    >
                                        <svg width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g opacity="0.4">
                                            <path
                                                d="M4.88076 14.6713C4.74978 14.2784 4.32504 14.066 3.93208 14.197C3.53912 14.328 3.32675 14.7527 3.45774 15.1457L4.88076 14.6713ZM20.8808 15.1457C21.0117 14.7527 20.7994 14.328 20.4064 14.197C20.0135 14.066 19.5887 14.2784 19.4577 14.6713L20.8808 15.1457ZM4.16925 14.9085C3.45774 15.1457 3.45785 15.146 3.45797 15.1464C3.45802 15.1465 3.45815 15.1469 3.45825 15.1472C3.45845 15.1478 3.45868 15.1485 3.45895 15.1493C3.45948 15.1509 3.46013 15.1528 3.46092 15.1551C3.46249 15.1597 3.46456 15.1657 3.46716 15.1731C3.47235 15.188 3.47961 15.2084 3.48902 15.2341C3.50782 15.2854 3.53521 15.3576 3.5717 15.4477C3.64461 15.6279 3.7542 15.8805 3.90468 16.1814C4.2048 16.7817 4.67223 17.5836 5.34308 18.3886C6.68942 20.0043 8.88343 21.6585 12.1693 21.6585V20.1585C9.45507 20.1585 7.64908 18.8128 6.49542 17.4284C5.91627 16.7334 5.5087 16.0354 5.24632 15.5106C5.11555 15.2491 5.02201 15.0329 4.96212 14.8849C4.9322 14.811 4.91076 14.7543 4.89733 14.7177C4.89062 14.6994 4.88593 14.6861 4.88318 14.6783C4.88181 14.6744 4.88093 14.6718 4.88053 14.6706C4.88033 14.67 4.88025 14.6698 4.88029 14.6699C4.88031 14.67 4.88036 14.6701 4.88044 14.6704C4.88047 14.6705 4.88056 14.6707 4.88058 14.6708C4.88067 14.671 4.88076 14.6713 4.16925 14.9085ZM12.1693 21.6585C15.4551 21.6585 17.6491 20.0043 18.9954 18.3886C19.6663 17.5836 20.1337 16.7817 20.4338 16.1814C20.5843 15.8805 20.6939 15.6279 20.7668 15.4477C20.8033 15.3576 20.8307 15.2854 20.8495 15.2341C20.8589 15.2084 20.8662 15.188 20.8713 15.1731C20.8739 15.1657 20.876 15.1597 20.8776 15.1551C20.8784 15.1528 20.879 15.1509 20.8796 15.1493C20.8798 15.1485 20.8801 15.1478 20.8803 15.1472C20.8804 15.1469 20.8805 15.1465 20.8805 15.1464C20.8807 15.146 20.8808 15.1457 20.1693 14.9085C19.4577 14.6713 19.4578 14.671 19.4579 14.6708C19.4579 14.6707 19.458 14.6705 19.4581 14.6704C19.4581 14.6701 19.4582 14.67 19.4582 14.6699C19.4583 14.6698 19.4582 14.67 19.458 14.6706C19.4576 14.6718 19.4567 14.6744 19.4553 14.6783C19.4526 14.6861 19.4479 14.6994 19.4412 14.7177C19.4277 14.7543 19.4063 14.811 19.3764 14.8849C19.3165 15.0329 19.223 15.2491 19.0922 15.5106C18.8298 16.0354 18.4222 16.7334 17.8431 17.4284C16.6894 18.8128 14.8834 20.1585 12.1693 20.1585V21.6585Z"
                                                fill="currentColor"></path>
                                            <path d="M21.5183 19.2271C21.4293 19.2234 21.3427 19.196 21.2671 19.1465L16.3546 15.8924C16.2197 15.8026 16.1413 15.6537 16.148 15.4969C16.1546 15.34 16.2452 15.1982 16.3873 15.1202L21.5571 12.2926C21.7075 12.2106 21.8932 12.213 22.0416 12.3003C22.1907 12.387 22.2783 12.5436 22.2712 12.7096L22.014 18.7913C22.007 18.9573 21.9065 19.1059 21.7506 19.1797C21.6772 19.215 21.597 19.2305 21.5183 19.2271" fill="currentColor"></path>
                                            </g>
                                            <path
                                            d="M20.0742 10.0265C20.1886 10.4246 20.6041 10.6546 21.0022 10.5401C21.4003 10.4257 21.6302 10.0102 21.5158 9.61214L20.0742 10.0265ZM4.10803 8.88317C3.96071 9.27031 4.15513 9.70356 4.54226 9.85087C4.92939 9.99818 5.36265 9.80377 5.50996 9.41664L4.10803 8.88317ZM20.795 9.81934C21.5158 9.61214 21.5157 9.6118 21.5156 9.61144C21.5155 9.61129 21.5154 9.6109 21.5153 9.61059C21.5152 9.60998 21.515 9.60928 21.5147 9.60848C21.5143 9.60689 21.5137 9.60493 21.513 9.6026C21.5116 9.59795 21.5098 9.59184 21.5075 9.58431C21.503 9.56925 21.4966 9.54853 21.4882 9.52251C21.4716 9.47048 21.4473 9.39719 21.4146 9.3056C21.3493 9.12256 21.2503 8.8656 21.1126 8.55861C20.8378 7.94634 20.4044 7.12552 19.7678 6.29313C18.4902 4.62261 16.3673 2.87801 13.0844 2.74053L13.0216 4.23922C15.7334 4.35278 17.4816 5.77291 18.5763 7.20436C19.1258 7.92295 19.5038 8.63743 19.744 9.17271C19.8638 9.43949 19.9482 9.65937 20.0018 9.80972C20.0286 9.88483 20.0477 9.94238 20.0596 9.97951C20.0655 9.99808 20.0696 10.0115 20.072 10.0195C20.0732 10.0235 20.074 10.0261 20.0744 10.0273C20.0746 10.0278 20.0746 10.0281 20.0746 10.028C20.0746 10.0279 20.0745 10.0278 20.0745 10.0275C20.0744 10.0274 20.0744 10.0272 20.0743 10.0271C20.0743 10.0268 20.0742 10.0265 20.795 9.81934ZM13.0844 2.74053C9.80146 2.60306 7.54016 4.16407 6.12741 5.72193C5.42345 6.49818 4.92288 7.27989 4.59791 7.86704C4.43497 8.16144 4.31491 8.40923 4.23452 8.58617C4.1943 8.67471 4.16391 8.7457 4.14298 8.79616C4.13251 8.82139 4.1244 8.84151 4.11859 8.85613C4.11568 8.86344 4.11336 8.86938 4.1116 8.8739C4.11072 8.87616 4.10998 8.87807 4.10939 8.87962C4.10909 8.88039 4.10883 8.88108 4.1086 8.88167C4.10849 8.88196 4.10834 8.88234 4.10829 8.88249C4.10815 8.88284 4.10803 8.88317 4.80899 9.14991C5.50996 9.41664 5.50985 9.41692 5.50975 9.41719C5.50973 9.41725 5.50964 9.41749 5.50959 9.4176C5.5095 9.41784 5.50945 9.41798 5.50942 9.41804C5.50938 9.41816 5.50947 9.41792 5.50969 9.41734C5.51014 9.41619 5.51113 9.41365 5.51267 9.40979C5.51574 9.40206 5.52099 9.38901 5.52846 9.37101C5.5434 9.335 5.56719 9.27924 5.60018 9.20664C5.66621 9.0613 5.76871 8.84925 5.91031 8.59341C6.19442 8.08008 6.63084 7.39971 7.23855 6.72958C8.44912 5.39466 10.3098 4.12566 13.0216 4.23922L13.0844 2.74053Z"
                                            fill="currentColor"></path>
                                            <path d="M8.78337 9.33604C8.72981 9.40713 8.65805 9.46292 8.57443 9.49703L3.1072 11.6951C2.95672 11.7552 2.78966 11.7352 2.66427 11.6407C2.53887 11.5462 2.47359 11.3912 2.48993 11.2299L3.09576 5.36863C3.11367 5.19823 3.22102 5.04666 3.37711 4.97402C3.5331 4.9005 3.71173 4.91728 3.84442 5.01726L8.70581 8.68052C8.8385 8.78051 8.90387 8.94759 8.8762 9.1178C8.86358 9.19825 8.83082 9.27308 8.78337 9.33604" fill="currentColor"></path>
                                        </svg>
                                    </button>


                                    <button class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#addExpertModal">
                                        <span class="btn-inner mr-5">
                                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-24"><path d="M12 4V20M20 12H4" stroke="currentColor"strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                        </span>
                                        Agregar
                                    </button>
                                </div>

                                </div>
                            </div>

                            <div class="card-body px-0">
                                <div class="table-responsive">
                                    <table
                                        id="user-list-table"
                                        className="table table-striped"
                                        role="grid"
                                        data-toggle="data-table"
                                    >
                                        <thead>
                                            <tr className="ligth">
                                                <th>Experto</th>
                                                <th>Email</th>
                                                <th>Estado</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {loadingExperts ? (
                                                <tr>
                                                    <td colSpan="4" className="text-center py-4">
                                                        <div className="d-flex flex-column align-items-center justify-content-center gap-2">
                                                            <div className="col-md-12 col-sm-4 mb-4">
                                                                <div className="iq-loader-box">
                                                                    <div className="iq-loader-1"></div>
                                                                </div>
                                                            </div>

                                                            <span className="text-muted">
                                                                Cargando expertos...
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : errorMessage ? (
                                                <tr>
                                                    <td colSpan="4" className="text-center py-4 text-danger">
                                                        {errorMessage}
                                                    </td>
                                                </tr>
                                            ) : paginatedItems.length === 0 ? (
                                                <tr>
                                                    <td colSpan="4" className="text-center py-4">
                                                        No hay instructores registrados.
                                                    </td>
                                                </tr>
                                            ) : (
                                                paginatedItems.map((item) => (
                                                    <tr key={item.Instructor_ID}>
                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <img
                                                                    className="rounded-circle bg-primary-subtle p-1 me-3"
                                                                    src={
                                                                        item.Instructor_Foto ||
                                                                        "../../assets/images/table/7.png"
                                                                    }
                                                                    alt={item.Instructor_Nombre}
                                                                    loading="lazy"
                                                                    style={{
                                                                        width: "65px",
                                                                        height: "65px",
                                                                        objectFit: "cover",
                                                                    }}
                                                                />
                                                                <div className="media-support-info">
                                                                    <h5 className="iq-sub-label mb-0">
                                                                        {item.Instructor_Nombre}
                                                                    </h5>
                                                                    <p className="mb-0">
                                                                        {item.Instructor_Puesto || "Sin puesto"}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </td>

                                                        <td>{item.Instructor_Correo || "Sin correo"}</td>

                                                        <td>
                                                            {Number(item.Instructor_Activo) === 1 ? (
                                                                <span className="badge bg-success-subtle p-2 text-success">
                                                                    Activo
                                                                </span>
                                                            ) : (
                                                                <span className="badge bg-danger-subtle p-2 text-danger">
                                                                    Inactivo
                                                                </span>
                                                            )}
                                                        </td>

                                                        <td>
                                                            <div className="d-flex">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-icon btn-info-subtle ms-2"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#viewExpertModal"
                                                                    onClick={() => handleViewInstructor(item)}
                                                                >
                                                                    <span className="btn-inner">
                                                                        <svg
                                                                            className="icon-32"
                                                                            width="32"
                                                                            viewBox="0 0 24 24"
                                                                            fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path
                                                                                opacity="0.4"
                                                                                fillRule="evenodd"
                                                                                clipRule="evenodd"
                                                                                d="M17.7366 6.04606C19.4439 7.36388 20.8976 9.29455 21.9415 11.7091C22.0195 11.8924 22.0195 12.1067 21.9415 12.2812C19.8537 17.1103 16.1366 20 12 20H11.9902C7.86341 20 4.14634 17.1103 2.05854 12.2812C1.98049 12.1067 1.98049 11.8924 2.05854 11.7091C4.14634 6.87903 7.86341 4 11.9902 4H12C14.0683 4 16.0293 4.71758 17.7366 6.04606ZM8.09756 12C8.09756 14.1333 9.8439 15.8691 12 15.8691C14.1463 15.8691 15.8927 14.1333 15.8927 12C15.8927 9.85697 14.1463 8.12121 12 8.12121C9.8439 8.12121 8.09756 9.85697 8.09756 12Z"
                                                                                fill="currentColor"
                                                                            />
                                                                            <path
                                                                                d="M14.4308 11.997C14.4308 13.3255 13.3381 14.4115 12.0015 14.4115C10.6552 14.4115 9.5625 13.3255 9.5625 11.997C9.5625 11.8321 9.58201 11.678 9.61128 11.5228H9.66006C10.743 11.5228 11.621 10.6695 11.6601 9.60184C11.7674 9.58342 11.8845 9.57275 12.0015 9.57275C13.3381 9.57275 14.4308 10.6588 14.4308 11.997Z"
                                                                                fill="currentColor"
                                                                            />
                                                                        </svg>
                                                                    </span>
                                                                </button>

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-icon btn-warning-subtle  ms-2"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#editExpertModal"
                                                                    onClick={() => handleEditInstructor(item)}
                                                                >
                                                                    <span className="btn-inner">
                                                                        <svg
                                                                            className="icon-32"
                                                                            width="32"
                                                                            viewBox="0 0 24 24"
                                                                            fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path
                                                                                opacity="0.4"
                                                                                d="M19.9927 18.9534H14.2984C13.7429 18.9534 13.291 19.4124 13.291 19.9767C13.291 20.5422 13.7429 21.0001 14.2984 21.0001H19.9927C20.5483 21.0001 21.0001 20.5422 21.0001 19.9767C21.0001 19.4124 20.5483 18.9534 19.9927 18.9534Z"
                                                                                fill="currentColor"
                                                                            ></path>
                                                                            <path
                                                                                d="M10.309 6.90385L15.7049 11.2639C15.835 11.3682 15.8573 11.5596 15.7557 11.6929L9.35874 20.0282C8.95662 20.5431 8.36402 20.8344 7.72908 20.8452L4.23696 20.8882C4.05071 20.8903 3.88775 20.7613 3.84542 20.5764L3.05175 17.1258C2.91419 16.4915 3.05175 15.8358 3.45388 15.3306L9.88256 6.95545C9.98627 6.82108 10.1778 6.79743 10.309 6.90385Z"
                                                                                fill="currentColor"
                                                                            ></path>
                                                                            <path
                                                                                opacity="0.4"
                                                                                d="M18.1208 8.66544L17.0806 9.96401C16.9758 10.0962 16.7874 10.1177 16.6573 10.0124C15.3927 8.98901 12.1545 6.36285 11.2561 5.63509C11.1249 5.52759 11.1069 5.33625 11.2127 5.20295L12.2159 3.95706C13.126 2.78534 14.7133 2.67784 15.9938 3.69906L17.4647 4.87078C18.0679 5.34377 18.47 5.96726 18.6076 6.62299C18.7663 7.3443 18.597 8.0527 18.1208 8.66544Z"
                                                                                fill="currentColor"
                                                                            ></path>
                                                                        </svg>
                                                                    </span>
                                                                </button>

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-icon btn-danger-subtle  ms-2"
                                                                    onClick={() => handleDeactivateExpert(item)}
                                                                >
                                                                    <span className="btn-inner">
                                                                        <svg
                                                                            className="icon-32"
                                                                            width="32"
                                                                            viewBox="0 0 24 24"
                                                                            fill="none"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                            <path
                                                                                opacity="0.4"
                                                                                d="M19.643 9.48851C19.643 9.5565 19.11 16.2973 18.8056 19.1342C18.615 20.8751 17.4927 21.9311 15.8092 21.9611C14.5157 21.9901 13.2494 22.0001 12.0036 22.0001C10.6809 22.0001 9.38741 21.9901 8.13185 21.9611C6.50477 21.9221 5.38147 20.8451 5.20057 19.1342C4.88741 16.2873 4.36418 9.5565 4.35445 9.48851C4.34473 9.28351 4.41086 9.08852 4.54507 8.93053C4.67734 8.78453 4.86796 8.69653 5.06831 8.69653H18.9388C19.1382 8.69653 19.3191 8.78453 19.4621 8.93053C19.5953 9.08852 19.6624 9.28351 19.643 9.48851Z"
                                                                                fill="currentColor"
                                                                            ></path>
                                                                            <path
                                                                                d="M21 5.97686C21 5.56588 20.6761 5.24389 20.2871 5.24389H17.3714C16.7781 5.24389 16.2627 4.8219 16.1304 4.22692L15.967 3.49795C15.7385 2.61698 14.9498 2 14.0647 2H9.93624C9.0415 2 8.26054 2.61698 8.02323 3.54595L7.87054 4.22792C7.7373 4.8219 7.22185 5.24389 6.62957 5.24389H3.71385C3.32386 5.24389 3 5.56588 3 5.97686V6.35685C3 6.75783 3.32386 7.08982 3.71385 7.08982H20.2871C20.6761 7.08982 21 6.75783 21 6.35685V5.97686Z"
                                                                                fill="currentColor"
                                                                            ></path>
                                                                        </svg>
                                                                    </span>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <UniversalPagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                totalItems={totalItems}
                                startItem={startItem}
                                endItem={endItem}
                                visiblePages={visiblePages}
                                onPageChange={goToPage}
                                onPrevious={goToPreviousPage}
                                onNext={goToNextPage}
                                hasPreviousPage={hasPreviousPage}
                                hasNextPage={hasNextPage}
                            />
                        </div>
                    </div>
                </div>

                {/* Modal para agregar Experto */}
                <div
                    className="modal fade"
                    id="addExpertModal"
                    tabIndex="-1"
                    aria-labelledby="addExpertModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <form onSubmit={handleSubmit}>
                                <div className="modal-header">
                                    <h5 className="modal-title" id="addExpertModalLabel">
                                        Agregar Experto
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        disabled={isSubmitting}
                                    ></button>
                                </div>

                                <div className="modal-body">
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label" htmlFor="nombre">
                                                Nombre Completo: <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                id="nombre"
                                                type="text"
                                                className={`form-control ${
                                                    showValidation && isNombreInvalid ? "is-invalid" : ""
                                                }`}
                                                placeholder="Ingresa el nombre completo del experto"
                                                value={form.nombre}
                                                onChange={handleChange}
                                                disabled={isSubmitting}
                                            />
                                            {showValidation && isNombreInvalid && (
                                                <div className="invalid-feedback">
                                                    El nombre es obligatorio.
                                                </div>
                                            )}
                                        </div>

                                        <div className="col-md-6 mb-4">
                                            <label className="form-label" htmlFor="correo">
                                                Correo Electrónico:
                                            </label>
                                            <input
                                                id="correo"
                                                type="email"
                                                className="form-control"
                                                placeholder="Ingresa el correo electrónico del experto"
                                                value={form.correo}
                                                onChange={handleChange}
                                                disabled={isSubmitting}
                                            />
                                        </div>

                                        <div className="col-md-12">
                                            <label className="form-label" htmlFor="puesto">
                                                Puesto: <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                id="puesto"
                                                type="text"
                                                className={`form-control ${
                                                    showValidation && isPuestoInvalid ? "is-invalid" : ""
                                                }`}
                                                placeholder="Ingresa el puesto del experto"
                                                value={form.puesto}
                                                onChange={handleChange}
                                                disabled={isSubmitting}
                                            />
                                            {showValidation && isPuestoInvalid && (
                                                <div className="invalid-feedback">
                                                    El puesto es obligatorio.
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col">
                                            <label className="form-label">
                                                Biografía: 
                                            </label>

                                            
                                                <ReactQuill
                                                    theme="snow"
                                                    value={form.bio}
                                                    onChange={(value) =>
                                                        setForm((prev) => ({
                                                            ...prev,
                                                            bio: value,
                                                        }))
                                                    }
                                                    modules={quillModules}
                                                    formats={quillFormats}
                                                    readOnly={isSubmitting}
                                                    placeholder="Escribe la biografía del instructor..."
                                                />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col">
                                            <label className="form-label" htmlFor="customFile1">
                                                Selecciona una imagen: <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                ref={fileInputRef}
                                                className={`form-control ${
                                                    showValidation && isPhotoInvalid ? "is-invalid" : ""
                                                }`}
                                                type="file"
                                                id="customFile1"
                                                accept=".jpg,.jpeg,.png,.webp"
                                                onChange={handleFileChange}
                                                disabled={isSubmitting}
                                            />
                                            {showValidation && isPhotoInvalid && (
                                                <div className="invalid-feedback">
                                                    La imagen es obligatoria.
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {alert.message && (
                                    <div
                                        className={`mb-3 alert alert-${
                                            alert.type === "danger" ? "danger" : alert.type
                                        } alert-dismissible fade show`}
                                        role="alert"
                                    >
                                        <span>{alert.message}</span>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setAlert({ type: "", message: "" })}
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                )}

                                {errorMessage && (
                                    <div className="alert alert-danger" role="alert">
                                        {errorMessage}
                                    </div>
                                )}
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-danger"
                                        data-bs-dismiss="modal"
                                        disabled={isSubmitting}
                                    >
                                        Cerrar
                                    </button>

                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? "Agregando..." : "Agregar"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                {/* Modal para ver Experto */}
                <div
                    className="modal fade"
                    id="viewExpertModal"
                    tabIndex="-1"
                    aria-labelledby="viewExpertModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="viewExpertModalLabel">
                                    Detalle del Experto
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>

                            <div className="modal-body">
                                {loadingViewExpert ? (
                                    <div className="text-center py-4">
                                        Cargando detalle del instructor...
                                    </div>
                                ) : !selectedExpert ? (
                                    <div className="alert alert-info mb-0" role="alert">
                                        No hay información del instructor para mostrar.
                                    </div>
                                ) : (
                                    <div className="row">
                                        <div className="col-md-4 text-center mb-3 mb-md-0">
                                            <img
                                                src={
                                                    selectedExpert.Instructor_Foto ||
                                                    "../../assets/images/table/7.png"
                                                }
                                                alt={selectedExpert.Instructor_Nombre}
                                                className="img-fluid rounded shadow-sm"
                                                style={{
                                                    width: "100%",
                                                    maxWidth: "260px",
                                                    height: "260px",
                                                    objectFit: "cover",
                                                }}
                                            />
                                        </div>

                                        <div className="col-md-8">
                                            <h4 className="mb-2">
                                                {selectedExpert.Instructor_Nombre || "Sin nombre"}
                                            </h4>

                                            <p className="mb-2">
                                                <strong>Puesto:</strong>{" "}
                                                {selectedExpert.Instructor_Puesto || "Sin puesto"}
                                            </p>

                                            <p className="mb-2">
                                                <strong>Correo:</strong>{" "}
                                                {selectedExpert.Instructor_Correo || "Sin correo"}
                                            </p>

                                            <p className="mb-3">
                                                <strong>Estado:</strong>{" "}
                                                {Number(selectedExpert.Instructor_Activo) === 1 ? (
                                                    <span className="badge bg-success-subtle p-2 text-success">
                                                        Activo
                                                    </span>
                                                ) : (
                                                    <span className="badge bg-danger-subtle p-2 text-danger">
                                                        Inactivo
                                                    </span>
                                                )}
                                            </p>

                                            <div>
                                                <strong>Biografía:</strong>
                                                <div
                                                    className="border rounded p-3 mt-2"
                                                    style={{ maxHeight: "260px", overflowY: "auto" }}
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            selectedExpert.Instructor_Bio ||
                                                            "<p class='mb-0'>Sin biografía</p>",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal"
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal para editar Experto */}
                <div
                    className="modal fade"
                    id="editExpertModal"
                    tabIndex="-1"
                    aria-labelledby="editExpertModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <form onSubmit={handleUpdateInstructor}>
                                <div className="modal-header">
                                    <h5 className="modal-title" id="editExpertModalLabel">
                                        Editar Experto
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        disabled={isUpdatingExpert}
                                    ></button>
                                </div>

                                <div className="modal-body">

                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <label className="form-label" htmlFor="nombre">
                                                Nombre Completo: <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                id="nombre"
                                                type="text"
                                                className={`form-control ${
                                                    showEditValidation && isEditNombreInvalid ? "is-invalid" : ""
                                                }`}
                                                placeholder="Ingresa el nombre completo del experto"
                                                value={editForm.nombre}
                                                onChange={handleEditInputChange}
                                                disabled={isUpdatingExpert}
                                            />
                                            {showEditValidation && isEditNombreInvalid && (
                                                <div className="invalid-feedback">
                                                    El nombre es obligatorio.
                                                </div>
                                            )}
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-label" htmlFor="correo">
                                                Correo Electrónico:
                                            </label>
                                            <input
                                                id="correo"
                                                type="email"
                                                className="form-control"
                                                placeholder="Ingresa el correo electrónico del experto"
                                                value={editForm.correo}
                                                onChange={handleEditInputChange}
                                                disabled={isUpdatingExpert}
                                            />
                                        </div>

                                        <div className="col-md-12">
                                            <label className="form-label" htmlFor="puesto">
                                                Puesto: <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                id="puesto"
                                                type="text"
                                                className={`form-control ${
                                                    showEditValidation && isEditPuestoInvalid ? "is-invalid" : ""
                                                }`}
                                                placeholder="Ingresa el puesto del experto"
                                                value={editForm.puesto}
                                                onChange={handleEditInputChange}
                                                disabled={isUpdatingExpert}
                                            />
                                            {showEditValidation && isEditPuestoInvalid && (
                                                <div className="invalid-feedback">
                                                    El puesto es obligatorio.
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col">
                                            <label className="form-label">
                                                Biografía: 
                                            </label>
                                                <ReactQuill
                                                    theme="snow"
                                                    value={editForm.bio}
                                                    onChange={(value) =>
                                                        setEditForm((prev) => ({
                                                            ...prev,
                                                            bio: value,
                                                        }))
                                                    }
                                                    modules={quillModules}
                                                    formats={quillFormats}
                                                    readOnly={isUpdatingExpert}
                                                    placeholder="Escribe la biografía del instructor..."
                                                />
                                        </div>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-7">
                                            <label className="form-label" htmlFor="editExpertPhoto">
                                                Reemplazar imagen:
                                            </label>
                                            <input
                                                ref={editFileInputRef}
                                                className="form-control"
                                                type="file"
                                                id="editExpertPhoto"
                                                accept=".jpg,.jpeg,.png,.webp"
                                                onChange={handleEditPhotoChange}
                                                disabled={isUpdatingExpert}
                                            />
                                            <small className="text-muted">
                                                La imagen es opcional al editar. Si cargas una nueva, reemplazará la actual.
                                            </small>
                                        </div>

                                        <div className="col-md-5">
                                            <label className="form-label">Imagen actual:</label>
                                            <div className="text-center border rounded p-2">
                                                <img
                                                    src={
                                                        editPhoto
                                                            ? URL.createObjectURL(editPhoto)
                                                            : editForm.fotoActual || "../../assets/images/table/7.png"
                                                    }
                                                    alt="Vista previa del instructor"
                                                    className="img-fluid rounded"
                                                    style={{
                                                        width: "100%",
                                                        maxWidth: "180px",
                                                        height: "180px",
                                                        objectFit: "cover",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {alert.message && (
                                        <div
                                            className={`mb-3 alert alert-${
                                                alert.type === "danger" ? "danger" : alert.type
                                            } alert-dismissible fade show`}
                                            role="alert"
                                        >
                                            <span>{alert.message}</span>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                onClick={() => setAlert({ type: "", message: "" })}
                                                aria-label="Close"
                                            ></button>
                                        </div>
                                    )}

                                    {errorMessage && (
                                        <div className="alert alert-danger" role="alert">
                                            {errorMessage}
                                        </div>
                                    )}
                                </div>

                                

                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-danger"
                                        data-bs-dismiss="modal"
                                        disabled={isUpdatingExpert}
                                    >
                                        Cerrar
                                    </button>

                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={isUpdatingExpert}
                                    >
                                        {isUpdatingExpert ? "Guardando..." : "Guardar cambios"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </main>
        </>
    )
}

export default Experts